<div class="accordion-item sendgroup cursor-pointer rounded-0">
  <div class="accordion-header justify-content-between bg-light" id="{{sendgroup.sendGroupGuid}}">
    <div class="p-3">
      <h3 class="mb-0 text-primary cursor-pointer active default-font-size">
        <div class="float-end">
          <ng-container *ngIf="HasAnySendGroupActionEnabled">
            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
              <li *ngIf="AllowsChangingSendGroupName"><a class="dropdown-item" (click)="editName()"
                  translate="Button.Name"></a></li>
              <li *ngIf="AllowsDeadlineEdit"><a class="dropdown-item" (click)="editDeadline()"
                  translate="Button.Deadline"></a> </li>
              <li *ngIf="AllowsResendInvites"><a class="dropdown-item" (click)="resendInvite()"
                  translate="Button.Reminder"></a> </li>
              <li *ngIf="AllowsDeadlineDaysEdit"><a class="dropdown-item" (click)="editDeadlineDays()"
                  translate="Button.DeadlineDays"></a>
            </ul>
          </ng-container>
        </div>
        <div data-bs-toggle="collapse" [attr.data-bs-target]="'#' + sendgroup.sendGroupGuid + '-panel'"
          aria-expanded="false" [attr.aria-controls]="'#' + sendgroup.sendGroupGuid + '-panel'">
          <div class="cursor-pointer">{{ getTranslatedSendGroupName(sendgroup.sendGroupName) }}</div>
          <div class="d-block mt-1">
            <!-- <pillbadge-status-display [data]="sendgroup.deadline | date:'dd-MM-yyyy HH:mm'" [status]="'Warning'" [iconTag]="'stopwatch'" [disable]="false"></pillbadge-status-display> -->
            <!-- FUTURE sendgroup, not Send-->
            <ng-container *ngIf="HasNoSendDate">
              <pillbadge-status-display [data]="'Request.Status.FutureSendGroup' | translate" [status]="'Info'"
                [iconTag]="'envelope'" [disable]="true"></pillbadge-status-display>
            </ng-container>

            <!-- has been Send:-->
            <!-- <ng-container *ngIf="HasSendDate">
              <pillbadge-status-display [data]="sendgroup.madeActiveDate | valueByTypePipe : DataTypeEnum.SendDate"
                [status]="'Info'" [iconTag]="'envelope-open'"></pillbadge-status-display>
            </ng-container> -->

            <!-- has been Completed:-->
            <ng-container *ngIf="IsCompletedSendGroup">
              <ng-container *ngIf="HasCompletionDate">
                <pillbadge-status-display
                  [data]="sendgroup.completionDate | valueByTypePipe : DataTypeEnum.CompletionDate" [status]="'Success'"
                  [iconTag]="'check2'"></pillbadge-status-display>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!IsCompletedSendGroup">
              <!-- has an ACTIVE deadline:-->
              <ng-container *ngIf="HasDeadline">
                <pillbadge-status-display [data]="sendgroup.deadline | valueByTypePipe : DataTypeEnum.DateTime"
                  [status]="'Warning'" [iconTag]="'stopwatch'"></pillbadge-status-display>
              </ng-container>

              <!-- has an FUTURE deadlineDAYS:-->
              <ng-container *ngIf="HasDeadlineDays">
                <pillbadge-status-display [data]="sendgroup.deadlineDays | valueByTypePipe : DataTypeEnum.PlusDays"
                  [status]="'Warning'" [iconTag]="'stopwatch'" [disable]="true"></pillbadge-status-display>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </h3>
    </div>
  </div>
  <div [id]="'' + sendgroup.sendGroupGuid + '-panel'" class="accordion-collapse collapse indent"
    aria-labelledby="sendgroups" data-bs-parent="#accordion">
    <div class="accordion-body p-0 h-100">
      <ng-container
        *ngFor="let actorInSendgroup of actorsInSendgroup; int let i = index; let isFirstItemOfPersonInSendGroup = first; let isLastItemOfPersonInSendGroup = last;">
        <ng-container *ngIf="!actorInSendgroup.grouped">
          <mobile-request-status-sendgroup-action-row [actorInSendgroup]="actorInSendgroup"
            [sendgroupStatus]="sendgroupStatus"></mobile-request-status-sendgroup-action-row>
        </ng-container>
        <ng-container *ngIf="actorInSendgroup.grouped">
          <mobile-request-status-sendgroup-action-row [actorInSendgroup]="actorInSendgroup"
            [sendgroupStatus]="sendgroupStatus" (click)="collapseCurrentSendgroup(actorInSendgroup.personGuid)"
            [last]="isLastItemOfPersonInSendGroup"
            [ngClass]="{ 'last-child-collapsed': isLastItemOfPersonInSendGroup && isCurrentSendGroupCollapsed(actorInSendgroup.personGuid) }"></mobile-request-status-sendgroup-action-row>
          <div #collapse="ngbCollapse" [ngbCollapse]="isCurrentSendGroupCollapsed(actorInSendgroup.personGuid)"
            [horizontal]="false"
            [ngClass]="{ 'last-child-expanded': isLastItemOfPersonInSendGroup && !isCurrentSendGroupCollapsed(actorInSendgroup.personGuid) }">
            <!-- Expandable list of actions by person -->
            <mobile-request-status-actions-by-person
              [actorsOfSendgroup]="getActionsByPerson(actorInSendgroup.personGuid)" [sortingAllowed]="sortingAllowed"
              [sendgroupStatus]="sendgroupStatus"></mobile-request-status-actions-by-person>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>